import axios from "axios";
import { ApiConfig } from "../constants/apiConfig";
import { studentHeaders } from "./apiClient";

const endpoint = `${ApiConfig.baseUrl}/presensi-ibadah`;

export const fetchPresensiIbadah = async (tanggal, agama) => {
  try {
    const response = await axios.get(endpoint, {
      params: { tanggal, ...(agama ? { agama } : {}) },
      headers: {
        ...studentHeaders(),
        Accept: "application/json",
      },
    });

    return { success: true, data: response.data };
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || "Gagal mengambil presensi ibadah.",
    };
  }
};

export const simpanPresensiIbadah = async (payload) => {
  try {
    const response = await axios.post(endpoint, payload, {
      headers: {
        ...studentHeaders(),
        Accept: "application/json",
      },
    });

    return { success: true, data: response.data };
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || "Gagal menyimpan presensi ibadah.",
    };
  }
};
